import { DashboardLayout } from '@/components/layout/DashboardLayout';
import PortfolioSensitivityMap from '@/components/investor/PortfolioSensitivityMap';

export default function PortfolioSensitivity() {
  return (
    <DashboardLayout>
      <PortfolioSensitivityMap base="USD" />
    </DashboardLayout>
  );
}
